import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import { IHierarchyTreeView } from './types';
import TreeViewSingle from 'components/TreeViewSingle';

const HierarchyTreeView: FC<IHierarchyTreeView> = ({
  loading,
  options = [],
  value,
  expandedNodes,
  renderLabel,
  onChange,
}) =>
  options.length > 0 ? (
    <TreeViewSingle
      nodes={options}
      onChange={onChange}
      value={value}
      expandedNodes={expandedNodes}
      renderLabel={renderLabel}
    />
  ) : (
    <Typography variant="body2">{loading ? 'Loading ...' : 'No Results found'}</Typography>
  );

export default React.memo(HierarchyTreeView);
